module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAsBAMAAADVzfZpAAAAAXNSR0IArs4c6QAAABVQTFRFAAAAAAYAAAUAAAoAAAQAAAMAAAMAO/6mrAAAAAd0Uk5TACwwNYmYmZ1xlP0AAABLSURBVDjLYxBxYoADZDYDg1uqAVY2kJcWjJXNwKCahlCIzGZgYA5DKERmA4EpkkLTUU1DUBNOGdymjWoZnFpw52DcuR53SYGzdAEAde1eiRpWBagAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/com/right_gray_double_arrow.png
// module id = 6rBr
// module chunks = 27